import { DateObject, GoatSurprised } from '@capsicum/common';
import { GenericDrawer, Text, Timer } from '@capsicum/common-web';
import { type NCWStakeComingSoonDrawerProps, useNCWStakeComingSoonDrawer } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

/**
 * Staking is unavailable in Poblano release; When the user clicks "Stake" button on NCW Home Page, this drawer is shown.
 * @param {() => void} closeModal the callback to close the drawer
 * @returns JSX this component
 */
export const NCWStakeComingSoonDrawer = ({ closeModal }: NCWStakeComingSoonDrawerProps) => {
	const { intlText } = useNCWStakeComingSoonDrawer();

	return (
		<GenericDrawer
			buttonText={intlText.closeButtonText}
			image={GoatSurprised}
			testID="ncw-stake-comingSoon-drawer"
			onButtonPress={closeModal}
		>
			<S.ChildrenWrapper>
				<S.TimerContainer>
					<Timer customText={intlText.labelText} expirationDate={new DateObject()} />
				</S.TimerContainer>
				<S.TextContainer>
					<Text variant="title6">{intlText.title}</Text>
					<S.Description1 variant="text3">{intlText.description1}</S.Description1>
					<S.Description2 variant="text3">{intlText.description2}</S.Description2>
				</S.TextContainer>
			</S.ChildrenWrapper>
		</GenericDrawer>
	);
};

namespace S {
	export const ChildrenWrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.large};
		margin-top: ${({ theme }) => theme.spacings.large};
	`;

	export const TimerContainer = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: center;
	`;

	export const TextContainer = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		align-items: center;
	`;

	export const Description1 = styled(Text)`
		text-align: center;
	`;

	export const Description2 = styled(Description1)`
		margin-vertible: ${({ theme }) => theme.spacings.small};
	`;
}
